import { Component, Input } from '@angular/core';

@Component({
  selector: 'logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.sass']
})
export class LogoComponent {
  @Input() logo: ReturnType<URL["toString"]> | null;
  @Input() alt: string | null;
  @Input() size: string;

  forceAlt: boolean = false;

  imageLoadError() {
    this.forceAlt = true;
  }
}
